<template>
  <div class="product">
    <div class="producttext">
      <div class="producttitle">
        產品介紹
        <span class="clickimg">點擊圖片查看產品規格</span>
      </div>
      <div class="productmodel">
        <div class="productitem">
          <img
            class="producticon"
            src="@/assets/monitors.svg"
            title="高畫質攝影機"
            alt="高畫質攝影機"
          />
          <h3 class="productitemname">高畫質攝影機</h3>
        </div>
        <div class="monitorscard">
          <el-card
            class="card"
            v-for="(productValue, index) in cameraModel"
            :key="index"
            shadow="hover"
            :body-style="{ padding: '0px', width: '100%' }"
          >
            <!--<div class="clickproduct">點擊圖片查看產品規格</div>-->
            <div
              class="productcardcontent"
              @mouseenter="checkCardHover(productValue)"
              @mouseleave="checkCardHover(productValue)"
              @click="
                cardmodal(
                  productValue.title,
                  productValue.img,
                  productValue.model
                )
              "
            >
              <div
                :class="
                  cardhover.hoverId == productValue.id && cardhover.ishover
                    ? 'productcardhovertrue'
                    : 'productcardhoverfalse'
                "
              >
                <p
                  class="productcardhover-title"
                  v-html="productValue.title"
                ></p>
                <div class="productcardhover-more">
                  <!-- <i class="el-icon-circle-plus-outline"></i> -->
                  查看產品規格
                </div>
              </div>
              <div class="productimg">
                <img
                  class="productcardimg"
                  :src="productValue.img"
                  :title="productValue.altName"
                  :alt="productValue.altName"
                />
              </div>
            </div>
            <h3 class="productcardtitle" v-html="productValue.title"></h3>
          </el-card>
        </div>
      </div>
      <div class="productmodel">
        <div class="productitem">
          <img
            class="producticon"
            src="@/assets/dvrs.svg"
            title="DVR監控主機"
            alt="DVR監控主機"
          />
          <h3 class="productitemname">DVR監控主機</h3>
        </div>
        <div class="dvrcard">
          <el-card
            class="card"
            v-for="(productValue, index) in dvrModel"
            :key="index"
            shadow="hover"
            :body-style="{ padding: '0px', width: '100%' }"
          >
            <!--<div class="clickproduct">點擊圖片查看產品規格</div>-->
            <div
              class="productcardcontent"
              @mouseenter="checkCardHover(productValue)"
              @mouseleave="checkCardHover(productValue)"
              @click="
                cardmodal(
                  productValue.title,
                  productValue.img,
                  productValue.model
                )
              "
            >
              <div
                :class="
                  cardhover.hoverId == productValue.id && cardhover.ishover
                    ? 'productcardhovertrue'
                    : 'productcardhoverfalse'
                "
              >
                <p
                  class="productcardhover-title"
                  v-html="productValue.title"
                ></p>
                <div class="productcardhover-more">
                  <!-- <i class="el-icon-circle-plus-outline"></i> -->
                  查看產品規格
                </div>
              </div>
              <div class="productimg">
                <img
                  class="productcardimg"
                  :src="productValue.img"
                  :title="productValue.altName"
                  :alt="productValue.altName"
                />
              </div>
            </div>
            <h3 class="productcardtitle" v-html="productValue.title"></h3>
          </el-card>
        </div>
      </div>
      <div class="productmodel">
        <div class="productitem">
          <img
            class="producticon"
            src="@/assets/doors.svg"
            title="門禁刷卡機"
            alt="門禁刷卡機"
          />
          <h3 class="productitemname">門禁刷卡機</h3>
        </div>
        <div class="doorcard">
          <el-card
            class="card"
            v-for="(productValue, index) in doorModel"
            :key="index"
            shadow="hover"
            :body-style="{ padding: '0px', width: '100%' }"
          >
            <!--<div class="clickproduct">點擊圖片查看產品規格</div>-->
            <div
              class="productcardcontent"
              @mouseenter="checkCardHover(productValue)"
              @mouseleave="checkCardHover(productValue)"
              @click="
                cardmodal(
                  productValue.title,
                  productValue.img,
                  productValue.model
                )
              "
            >
              <div
                :class="
                  cardhover.hoverId == productValue.id && cardhover.ishover
                    ? 'productcardhovertrue'
                    : 'productcardhoverfalse'
                "
              >
                <p
                  class="productcardhover-title"
                  v-html="productValue.title"
                ></p>
                <div class="productcardhover-more">
                  <!-- <i class="el-icon-circle-plus-outline"></i> -->
                  查看產品規格
                </div>
              </div>
              <div class="productimg">
                <img
                  class="productcardimg"
                  :src="productValue.img"
                  :title="productValue.altName"
                  :alt="productValue.altName"
                />
              </div>
            </div>
            <h3 class="productcardtitle" v-html="productValue.title"></h3>
          </el-card>
        </div>
      </div>

      <el-dialog
        :visible.sync="cardDialog"
        :modal="false"
        width="90%"
        top="20vh"
      >
        <div class="dialog-title">
          <span class="dialog-name" v-html="cardDialogTitle"></span>
          <img
            class="productmodelimg"
            :src="productModelImg"
            :title="cardDialogTitle"
            :alt="cardDialogTitle"
          />
        </div>
        <div class="productmodeltable">
          <el-card
            :class="[
              itemRow === 1 ? 'productmodelcardone' : 'productmodelcardoneup',
            ]"
            v-for="(item, index) in productModelValue"
            :key="index"
            shadow="hover"
          >
            <div class="modelType">{{ item.type }}</div>
            <div>
              <ul
                class="modelLi"
                v-for="(model, index) in item.typeModel"
                :key="index"
              >
                <li>{{ model.modelName }} : {{ model.modelValue }}</li>
              </ul>
            </div>
          </el-card>
        </div>
      </el-dialog>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      cardDialog: false,
      cardDialogTitle: "",
      productModelValue: "",
      productModelImg: "",
      itemRow: 0,
      cardhover: {
        ishover: false,
        hoverId: "",
      },
      cameraModel: [
        {
          id: 1,
          img: require("@/assets/product/CA220.png"),
          title: "CA-220<br>標準紅外線型高畫質攝影機",
          altName: "CA-220標準紅外線型高畫質攝影機",
          model: [
            {
              type: "規格",
              typeModel: [
                {
                  modelName: "影像感應裝置",
                  modelValue: "1/3 2.0Megapixel CMOS",
                },
                {
                  modelName: "掃瞄系統",
                  modelValue: "Progressive Scan",
                },
                {
                  modelName: "信號雜訊比",
                  modelValue: "46dB 以上",
                },
                {
                  modelName: "影像輸出",
                  modelValue: "1080P",
                },
                {
                  modelName: "鏡頭",
                  modelValue: "4mm / 6mm / 8mm",
                },
                {
                  modelName: "最低照度",
                  modelValue: "0.01Lux(AGC ON),0Lux(IR ON)",
                },
                {
                  modelName: "IR 照射距離",
                  modelValue: "30M (HIGH POWER LEDx6 )",
                },
                {
                  modelName: "數位類比切換",
                  modelValue: "有",
                },
                {
                  modelName: "電子快門",
                  modelValue: "自動",
                },
                {
                  modelName: "增益控制",
                  modelValue: "多段可調",
                },
                {
                  modelName: "輸出格式",
                  modelValue: "AHD/TVI/CVI/960H可調",
                },
                {
                  modelName: "電源",
                  modelValue: "DC12V+10% / 100mA(430mA with IR ON)",
                },
                {
                  modelName: "工作温度",
                  modelValue: "-20°~ +50°C",
                },
                {
                  modelName: "外觀尺寸 (mm)",
                  modelValue: "70(W) X 70(H) X 115(D) (含雨遮80X80X220)",
                },
                {
                  modelName: "重量(g)",
                  modelValue: "1100",
                },
              ],
            },
          ],
        },
        {
          id: 2,
          img: require("@/assets/product/CA220K.png"),
          title: "CA-220K AHD<br>標準紅外線型高畫質數位攝影機",
          altName: "CA-220K AHD標準紅外線型高畫質數位攝影機",
          model: [
            {
              type: "規格",
              typeModel: [
                {
                  modelName: "影像感應裝置",
                  modelValue: '1/2.7" SONY323 2.0Megapixel AHD CMOS',
                },
                {
                  modelName: "掃瞄系統",
                  modelValue: "Progressive Scan",
                },
                {
                  modelName: "信號雜訊比",
                  modelValue: "46dB 以上",
                },
                {
                  modelName: "影像輸出",
                  modelValue: "1080P",
                },
                {
                  modelName: "鏡頭",
                  modelValue: "4mm / 6mm",
                },
                {
                  modelName: "最低照度",
                  modelValue: "0.01Lux(AGC ON),0Lux(IR ON)",
                },
                {
                  modelName: "IR 照射距離",
                  modelValue: "20M (3 HIGH POWER IR LED)",
                },
                {
                  modelName: "OSD",
                  modelValue: "內建",
                },
                {
                  modelName: "電子快門",
                  modelValue: "自動",
                },
                {
                  modelName: "增益控制",
                  modelValue: "可調",
                },
                {
                  modelName: "同軸線控",
                  modelValue: "有",
                },
                {
                  modelName: "電源",
                  modelValue: "DC12V+10% / 120mA(270mA with IR ON)",
                },
                {
                  modelName: "工作温度",
                  modelValue: "-10°~ +60°C",
                },
                {
                  modelName: "外觀尺寸 (mm)",
                  modelValue: "94(Ø) x 65(L)",
                },
                {
                  modelName: "附件",
                  modelValue: "螺絲 (壁掛、吸頂均可安裝)",
                },
              ],
            },
          ],
        },
        {
          id: 3,
          img: require("@/assets/product/UOIM50.png"),
          title: "UOI-M50<br>四合一標準型紅外線高畫質攝影機",
          altName: "UOI-M50四合一標準型紅外線高畫質攝影機",
          model: [
            {
              type: "規格",
              typeModel: [
                {
                  modelName: "影像感應裝置",
                  modelValue: "1/3 5.0Megapixel CMOS",
                },
                {
                  modelName: "掃瞄系統",
                  modelValue: "Progressive Scan",
                },
                {
                  modelName: "信號雜訊比",
                  modelValue: "65dB 以上",
                },
                {
                  modelName: "影像輸出",
                  modelValue: "5MP(12fps)",
                },
                {
                  modelName: "鏡頭",
                  modelValue: "4mm 、 6mm",
                },
                {
                  modelName: "最低照度",
                  modelValue: "0.01Lux(AGC ON),0.001Lux(IR ON)",
                },
                {
                  modelName: "IR 照射距離",
                  modelValue: "30M (HIGH POWER LEDx6 )",
                },
                {
                  modelName: "數位類比切換",
                  modelValue: "有(選單內選擇)",
                },
                {
                  modelName: "電子快門",
                  modelValue: "自動",
                },
                {
                  modelName: "數位訊號",
                  modelValue: "TVI/AHD/CVI 可切(選單內選擇)",
                },
                {
                  modelName: "電源",
                  modelValue: "DC12V+10% ",
                },
                {
                  modelName: "工作温度",
                  modelValue: "-10°~ +60°C",
                },
                {
                  modelName: "外觀尺寸 (mm)",
                  modelValue: "70(W) X 70(H) X 115(D) (含雨遮 80X80X220)",
                },
                {
                  modelName: "重量",
                  modelValue: "1100",
                },
              ],
            },
          ],
        },
        {
          id: 4,
          img: require("@/assets/product/UOI291.png"),
          title: "UOI-291 AHD<br>星光級高畫質攝影機",
          altName: "UOI-291 AHD星光級高畫質攝影機",
          model: [
            {
              type: "規格",
              typeModel: [
                {
                  modelName: "影像感應裝置",
                  modelValue: '1/2.8" SONY IMX291 2.0Megapixel CMOS',
                },
                {
                  modelName: "掃瞄系統",
                  modelValue: "Progressive Scan",
                },
                {
                  modelName: "信號雜訊比",
                  modelValue: "46dB 以上",
                },
                {
                  modelName: "影像輸出",
                  modelValue: "1080P",
                },
                {
                  modelName: "鏡頭",
                  modelValue: "4mm / 6mm",
                },
                {
                  modelName: "最低照度",
                  modelValue: "0.01Lux(AGC ON)",
                },
                {
                  modelName: "OSD 數位類比切換",
                  modelValue: "有",
                },
                {
                  modelName: "數位類比切換",
                  modelValue: "有(選單內選擇)",
                },
                {
                  modelName: "電子快門",
                  modelValue: "1/50(1/60)秒至 1/100,000 秒",
                },
                {
                  modelName: "增益控制",
                  modelValue: "Low/Middle/High",
                },
                {
                  modelName: "同軸線控",
                  modelValue: "YES",
                },
                {
                  modelName: "效果",
                  modelValue: "Freeze/Mirror/D-Zoom/NEG.IMAGE",
                },
                {
                  modelName: "紅外線",
                  modelValue: "無 IR 燈",
                },
                {
                  modelName: "電源",
                  modelValue: "DC12V+10% / 80mA",
                },
                {
                  modelName: "工作温度",
                  modelValue: "-20°~ +50°C",
                },
                {
                  modelName: "外觀尺寸 (mm)",
                  modelValue: "110(W) X 69(H) X 69(D)",
                },
                {
                  modelName: "重量(g)",
                  modelValue: "1000g",
                },
              ],
            },
          ],
        },
        {
          id: 5,
          img: require("@/assets/product/UOI3208.png"),
          title: "UOI-3208<br>戶外防護罩型 紅外線高畫質數位攝影機",
          altName: "UOI-3208戶外防護罩型 紅外線高畫質數位攝影機",
          model: [
            {
              type: "規格",
              typeModel: [
                {
                  modelName: "影像感應裝置",
                  modelValue: "1/2.9 2.0Megapixel CMO S",
                },
                {
                  modelName: "掃瞄系統",
                  modelValue: "Progressive Scan",
                },
                {
                  modelName: "信號雜訊比",
                  modelValue: "46dB 以上",
                },
                {
                  modelName: "影像輸出",
                  modelValue: "1080P",
                },
                {
                  modelName: "鏡頭",
                  modelValue: "2.8mm~12mm 可變焦",
                },
                {
                  modelName: "最低照度",
                  modelValue: "0.01Lux(AGC ON),0.001Lux(IR ON)",
                },
                {
                  modelName: "IR 照射距離",
                  modelValue: "50M (HIGH POWER LEDx6)",
                },
                {
                  modelName: "數位類比切換",
                  modelValue: "有",
                },
                {
                  modelName: "電子快門",
                  modelValue: "自動",
                },
                {
                  modelName: "數位訊號切換",
                  modelValue: "AHD/TVI/CVI/CVBS/1080P/720P",
                },
                {
                  modelName: "電源",
                  modelValue: "DC12V+10% / 120mA(270mA with IR ON)",
                },
                {
                  modelName: "工作温度",
                  modelValue: "-10°~ +60°C",
                },
                {
                  modelName: "外觀尺寸 (mm)",
                  modelValue: "130(Ø) x 280(L)",
                },
                {
                  modelName: "重量(g)",
                  modelValue: "1100",
                },
              ],
            },
          ],
        },
        {
          id: 6,
          img: require("@/assets/product/UOI291H.png"),
          title: "UOI-291H AHD<br>星光級防護罩級高畫質攝影機",
          altName: "UOI-291H AHD星光級防護罩級高畫質攝影機",
          model: [
            {
              type: "規格",
              typeModel: [
                {
                  modelName: "影像感應裝置",
                  modelValue: '1/2.8"High sensitivity2.0Megapixel CMOS',
                },
                {
                  modelName: "掃瞄系統",
                  modelValue: "Progressive Scan",
                },
                {
                  modelName: "信號雜訊比",
                  modelValue: "46dB 以上",
                },
                {
                  modelName: "影像輸出",
                  modelValue: "1080P",
                },
                {
                  modelName: "鏡頭",
                  modelValue: "4mm / 6mm",
                },
                {
                  modelName: "最低照度",
                  modelValue: "0.01Lux(AGC ON)",
                },
                {
                  modelName: "OSD 數位類比切換",
                  modelValue: "有",
                },
                {
                  modelName: "電子快門",
                  modelValue: "1/50(1/60)秒至 1/100,000 秒",
                },
                {
                  modelName: "增益控制",
                  modelValue: "Low/Middle/High",
                },
                {
                  modelName: "同軸線控 ",
                  modelValue: "YES",
                },
                {
                  modelName: "效果",
                  modelValue: "Freeze/Mirror/D-Zoom/NEG.IMAGE",
                },
                {
                  modelName: "電源",
                  modelValue: "DC12V+10% / 120mA",
                },
                {
                  modelName: "工作温度",
                  modelValue: "-20°~ +50°C",
                },
                {
                  modelName: "外觀尺寸 (mm)",
                  modelValue: "130(Ø) x 280(L)",
                },
                {
                  modelName: "重量(g)",
                  modelValue: "1000",
                },
              ],
            },
          ],
        },
        {
          id: 7,
          img: require("@/assets/product/UOI1080M.png"),
          title: "UOI-1080M AHD PIR型<br>高畫質數位攝影機",
          altName: "UOI-1080M AHD PIR型高畫質數位攝影機",
          model: [
            {
              type: "規格",
              typeModel: [
                {
                  modelName: "影像感應裝置",
                  modelValue: '1/3" 2.0Megapixel CMOS',
                },
                {
                  modelName: "掃瞄系統",
                  modelValue: "Progressive Scan",
                },
                {
                  modelName: "信號雜訊比",
                  modelValue: "58dB 以上",
                },
                {
                  modelName: "影像輸出",
                  modelValue: "1080P",
                },
                {
                  modelName: "鏡頭",
                  modelValue: "3.7mm",
                },
                {
                  modelName: "最低照度",
                  modelValue: "0.01Lux(AGC ON),0Lux(IR ON)",
                },
                {
                  modelName: "電子快門",
                  modelValue: "1/50(1/60)秒至 1/100,000 秒",
                },
                {
                  modelName: "增益控制",
                  modelValue: "Low/Middle/High",
                },
                {
                  modelName: "Digital Zoom/PIP",
                  modelValue: "On/Off(x2 ~ x64)",
                },
                {
                  modelName: "數位效果 ",
                  modelValue: "Freeze/Mirror/D-Zoom/NEG.IMAGE",
                },
                {
                  modelName: "電源",
                  modelValue: "DC12V+10% / 210mA(650mA with IR ON)",
                },
                {
                  modelName: "工作温度",
                  modelValue: "-10°~ +60°C",
                },
                {
                  modelName: "外觀尺寸 (mm)",
                  modelValue: "130(Ø) x 58(L)",
                },
              ],
            },
          ],
        },
        {
          id: 8,
          img: require("@/assets/product/UOI1080V01.png"),
          title: "UOI-1080V01 AHD<br>標準紅外線型高畫質攝影機",
          altName: "UOI-1080V01 AHD標準紅外線型高畫質攝影機",
          model: [
            {
              type: "規格",
              typeModel: [
                {
                  modelName: "影像感應裝置",
                  modelValue: '1/2.7" SC2035 2.0Megapixel CMOS',
                },
                {
                  modelName: "掃瞄系統",
                  modelValue: "Progressive Scan",
                },
                {
                  modelName: "信號雜訊比",
                  modelValue: "58dB 以上",
                },
                {
                  modelName: "影像輸出",
                  modelValue: "1080P",
                },
                {
                  modelName: "鏡頭",
                  modelValue: "3.6mm",
                },
                {
                  modelName: "最低照度",
                  modelValue: "0.01Lux(AGC ON),0.001Lux(IR ON)",
                },
                {
                  modelName: "數位類比切換",
                  modelValue: "有",
                },
                {
                  modelName: "電子快門",
                  modelValue: "Auto",
                },
                {
                  modelName: "增益控制",
                  modelValue: "Auto",
                },
                {
                  modelName: "效果",
                  modelValue: "仿煙霧偵測器外殼",
                },
                {
                  modelName: "電源",
                  modelValue: "DC12V+10% / 120mA",
                },
                {
                  modelName: "工作温度",
                  modelValue: "-10°~ +60°C",
                },
                {
                  modelName: "外觀尺寸 (mm)",
                  modelValue: "126(W) X 70(H)",
                },
                {
                  modelName: "重量(g)",
                  modelValue: "550",
                },
              ],
            },
          ],
        },
      ],
      dvrModel: [
        {
          id: 9,
          img: require("@/assets/product/DVR4.png"),
          title: "DVR4R監控主機",
          altName: "DVR4R監控主機",
          model: [
            {
              type: "影像",
              typeModel: [
                {
                  modelName: "影像輸入",
                  modelValue: "4 路 AHD / TVI / CVI /960H /IPCAM(Max for 2 IP)",
                },
                {
                  modelName: "HDMI 輸出",
                  modelValue: "1 影像輸出",
                },
                {
                  modelName: "VGA 輸出",
                  modelValue:
                    "1 VGA 輸出：1920x1080、1440x900、1366x768、1280x1024、1024x768",
                },
                {
                  modelName: "CVBS 輸出",
                  modelValue: "1 VIDEO 輸出，AV 端子訊號",
                },
              ],
            },
            {
              type: "聲音",
              typeModel: [
                {
                  modelName: "RCA 輸入",
                  modelValue: "4 RCA 聲音輸入",
                },
                {
                  modelName: "RCA 輸出",
                  modelValue: "1 RCA 聲音輸出",
                },
              ],
            },
            {
              type: "系統",
              typeModel: [
                {
                  modelName: "作業系統",
                  modelValue: "嵌入式 Linux 作業系統",
                },
                {
                  modelName: "內建硬碟",
                  modelValue: "支援 1 SATA 介面 ( HDDx1) ",
                },
                {
                  modelName: "外接硬碟",
                  modelValue: "無",
                },
                {
                  modelName: "I/O",
                  modelValue: "2 組 USB2.0、Alarm 4 輸入/1 輸出",
                },
                {
                  modelName: "PTZ 通訊協定",
                  modelValue: "RS-485 介面 (Pelco D/P)",
                },
                {
                  modelName: "電源",
                  modelValue: "12V/2A",
                },
                {
                  modelName: "消耗電流",
                  modelValue: "24W",
                },
              ],
            },
            {
              type: "顯示",
              typeModel: [
                {
                  modelName: "解析度",
                  modelValue: "4K2K(For HDMI)、1080P、720P、1024x768",
                },
                {
                  modelName: "分割畫面",
                  modelValue: "1、4、跳台",
                },
              ],
            },
            {
              type: "錄影",
              typeModel: [
                {
                  modelName: "錄影解析度",
                  modelValue: "5M、4M、3M(for IP)、1080P、720P、960H",
                },
                {
                  modelName: "錄影模式",
                  modelValue: "一般、位移、排程錄影",
                },
                {
                  modelName: "速度",
                  modelValue: "5MP : 24 張/秒、4MP : 32 張/秒、1080P：60 張/秒",
                },
                {
                  modelName: "警報錄影",
                  modelValue: "有",
                },
                {
                  modelName: "排程錄影",
                  modelValue: "有",
                },
              ],
            },
            {
              type: "回放",
              typeModel: [
                {
                  modelName: "顯示",
                  modelValue: "1、4",
                },
                {
                  modelName: "搜尋模式",
                  modelValue: "日期、時間、事件(位移)",
                },
                {
                  modelName: "數位放大",
                  modelValue: "有",
                },
                {
                  modelName: "快照",
                  modelValue: "有",
                },
                {
                  modelName: "控制",
                  modelValue: "一般、暫停、停止、快放/倒轉、單張、搜尋 BAR",
                },
              ],
            },
            {
              type: "網路",
              typeModel: [
                {
                  modelName: "網路介面",
                  modelValue: "10/100 乙太網路",
                },
                {
                  modelName: "通訊協定",
                  modelValue: "TCP/IP、SMTP、HTTP、DHCP、PPPoE (ADSL)、NTP",
                },
                {
                  modelName: "應用程式",
                  modelValue: "Windows 7/8/10",
                },
                {
                  modelName: "遠端監控",
                  modelValue: "IE 瀏覽器、CMS 軟體、桌面專用軟體",
                },
                {
                  modelName: "登入帳號",
                  modelValue: "1 Admin + 20 User",
                },
                {
                  modelName: "CMS 中控平台",
                  modelValue: "有",
                },
                {
                  modelName: "手機 APP",
                  modelValue: "iPhone、iPad、Android",
                },
                {
                  modelName: "事件傳輸",
                  modelValue: "E-mail、APP 推播",
                },
              ],
            },
            {
              type: "備份",
              typeModel: [
                {
                  modelName: "介面",
                  modelValue: "USB 2.0 遠端",
                },
                {
                  modelName: "備份方式",
                  modelValue: "網路遠端軟體、USB 隨身碟",
                },
              ],
            },
            {
              type: "警報",
              typeModel: [
                {
                  modelName: "位移偵測",
                  modelValue: "有",
                },
                {
                  modelName: "推播通知",
                  modelValue: "支援 APP 推播通知",
                },
                {
                  modelName: "事件紀錄",
                  modelValue:
                    "警報、位移、影像遺失、電源開關、錄影開關、遠端登入、硬碟錯誤",
                },
              ],
            },
            {
              type: "尺寸規格",
              typeModel: [
                {
                  modelName: "機身尺寸",
                  modelValue: "寬:260(mm) x 深:236(mm) x 高:48(mm)",
                },
              ],
            },
            {
              type: "OSD 及 DVR 控制",
              typeModel: [
                {
                  modelName: "GUI",
                  modelValue: "圖形化操作介面",
                },
                {
                  modelName: "多國語言",
                  modelValue: "中、英語言顯示操作",
                },
                {
                  modelName: "攝影機抬頭",
                  modelValue: "多國語言可任意由 PC 輸入",
                },
                {
                  modelName: "USB 滑鼠",
                  modelValue: "標準配備",
                },
                {
                  modelName: "UTC 控製",
                  modelValue: "有",
                },
                {
                  modelName: "系統升級",
                  modelValue: "經 USB 可更新 FIRMWARE(韌體)",
                },
              ],
            },
          ],
        },
        {
          id: 10,
          img: require("@/assets/product/DVR8.png"),
          title: "DVR8R監控主機",
          altName: "DVR8R監控主機",
          model: [
            {
              type: "影像",
              typeModel: [
                {
                  modelName: "影像輸入",
                  modelValue: "8 路 AHD / TVI / CVI /960H /IPCAM(Max for 2 IP)",
                },
                {
                  modelName: "HDMI 輸出",
                  modelValue: "1 影像輸出",
                },
                {
                  modelName: "VGA 輸出",
                  modelValue:
                    "1 VGA 輸出：1920x1080、1440x900、1366x768、1280x1024、1024x768",
                },
                {
                  modelName: "CVBS 輸出",
                  modelValue: "1 VIDEO 輸出，AV 端子訊號",
                },
              ],
            },
            {
              type: "聲音",
              typeModel: [
                {
                  modelName: "RCA 輸入",
                  modelValue: "4 RCA 聲音輸入",
                },
                {
                  modelName: "RCA 輸出",
                  modelValue: "1 RCA 聲音輸出",
                },
              ],
            },
            {
              type: "系統",
              typeModel: [
                {
                  modelName: "作業系統",
                  modelValue: "嵌入式 Linux 作業系統",
                },
                {
                  modelName: "內建硬碟",
                  modelValue: "支援 1 SATA 介面 ( HDDx1) ",
                },
                {
                  modelName: "外接硬碟",
                  modelValue: "無",
                },
                {
                  modelName: "I/O",
                  modelValue: "2 組 USB2.0、Alarm 4 輸入/1 輸出",
                },
                {
                  modelName: "PTZ 通訊協定",
                  modelValue: "RS-485 介面 (Pelco D/P)",
                },
                {
                  modelName: "電源",
                  modelValue: "12V/2A",
                },
                {
                  modelName: "消耗電流",
                  modelValue: "24W",
                },
              ],
            },
            {
              type: "顯示",
              typeModel: [
                {
                  modelName: "解析度",
                  modelValue: "4K2K(For HDMI)、1080P、720P、1024x768",
                },
                {
                  modelName: "分割畫面",
                  modelValue: "1、4、9、跳台",
                },
              ],
            },
            {
              type: "錄影",
              typeModel: [
                {
                  modelName: "錄影解析度",
                  modelValue: "5M、4M、3M(for IP)、1080P、720P、960H",
                },
                {
                  modelName: "錄影模式",
                  modelValue: "一般、位移、排程錄影",
                },
                {
                  modelName: "速度",
                  modelValue:
                    "5MP : 48 張/秒、4MP : 640 張/秒、1080P：120 張/秒",
                },
                {
                  modelName: "警報錄影",
                  modelValue: "有",
                },
                {
                  modelName: "排程錄影",
                  modelValue: "有",
                },
              ],
            },
            {
              type: "回放",
              typeModel: [
                {
                  modelName: "顯示",
                  modelValue: "1、4、9",
                },
                {
                  modelName: "搜尋模式",
                  modelValue: "日期、時間、事件(位移)",
                },
                {
                  modelName: "數位放大",
                  modelValue: "有",
                },
                {
                  modelName: "快照",
                  modelValue: "有",
                },
                {
                  modelName: "控制",
                  modelValue: "一般、暫停、停止、快放/倒轉、單張、搜尋 BAR",
                },
              ],
            },
            {
              type: "網路",
              typeModel: [
                {
                  modelName: "網路介面",
                  modelValue: "10/100 乙太網路",
                },
                {
                  modelName: "通訊協定",
                  modelValue: "TCP/IP、SMTP、HTTP、DHCP、PPPoE (ADSL)、NTP",
                },
                {
                  modelName: "應用程式",
                  modelValue: "Windows 7/8/10",
                },
                {
                  modelName: "遠端監控",
                  modelValue: "IE 瀏覽器、CMS 軟體、桌面專用軟體",
                },
                {
                  modelName: "登入帳號",
                  modelValue: "1 Admin + 20 User",
                },
                {
                  modelName: "CMS 中控平台",
                  modelValue: "有",
                },
                {
                  modelName: "手機 APP",
                  modelValue: "iPhone、iPad、Android",
                },
                {
                  modelName: "事件傳輸",
                  modelValue: "E-mail、APP 推播",
                },
              ],
            },
            {
              type: "備份",
              typeModel: [
                {
                  modelName: "介面",
                  modelValue: "USB 2.0 遠端",
                },
                {
                  modelName: "備份方式",
                  modelValue: "網路遠端軟體、USB 隨身碟",
                },
              ],
            },
            {
              type: "警報",
              typeModel: [
                {
                  modelName: "位移偵測",
                  modelValue: "有",
                },
                {
                  modelName: "推播通知",
                  modelValue: "支援 APP 推播通知",
                },
                {
                  modelName: "事件紀錄",
                  modelValue:
                    "警報、位移、影像遺失、電源開關、錄影開關、遠端登入、硬碟錯誤",
                },
              ],
            },
            {
              type: "尺寸規格",
              typeModel: [
                {
                  modelName: "機身尺寸",
                  modelValue: "寬:260(mm) x 深:236(mm) x 高:48(mm)",
                },
              ],
            },
            {
              type: "OSD 及 DVR 控制",
              typeModel: [
                {
                  modelName: "GUI",
                  modelValue: "圖形化操作介面",
                },
                {
                  modelName: "多國語言",
                  modelValue: "中、英語言顯示操作",
                },
                {
                  modelName: "攝影機抬頭",
                  modelValue: "多國語言可任意由 PC 輸入",
                },
                {
                  modelName: "USB 滑鼠",
                  modelValue: "標準配備",
                },
                {
                  modelName: "UTC 控製",
                  modelValue: "有",
                },
                {
                  modelName: "系統升級",
                  modelValue: "經 USB 可更新 FIRMWARE(韌體)",
                },
              ],
            },
          ],
        },
        {
          id: 11,
          img: require("@/assets/product/DVR16.png"),
          title: "DVR16R監控主機",
          altName: "DVR16R監控主機",
          model: [
            {
              type: "影像",
              typeModel: [
                {
                  modelName: "影像輸入",
                  modelValue:
                    "16 路 AHD / TVI / CVI /960H /IPCAM(Max for 2 IP)",
                },
                {
                  modelName: "HDMI 輸出",
                  modelValue: "1 影像輸出(最高支援 4K 解析度)",
                },
                {
                  modelName: "VGA 輸出",
                  modelValue:
                    "1 VGA 輸出：1920x1080、1440x900、1366x768、1280x1024、1024x768",
                },
                {
                  modelName: "CVBS 輸出",
                  modelValue: "1 VIDEO 輸出，AV 端子訊號",
                },
              ],
            },
            {
              type: "聲音",
              typeModel: [
                {
                  modelName: "RCA 輸入",
                  modelValue: "4 RCA 聲音輸入",
                },
                {
                  modelName: "RCA 輸出",
                  modelValue: "1 RCA 聲音輸出",
                },
              ],
            },
            {
              type: "系統",
              typeModel: [
                {
                  modelName: "作業系統",
                  modelValue: "嵌入式 Linux 作業系統",
                },
                {
                  modelName: "內建硬碟",
                  modelValue: "支援 2 SATA 介面 ( HDDx2) ",
                },
                {
                  modelName: "外接硬碟",
                  modelValue: "無",
                },
                {
                  modelName: "I/O",
                  modelValue: "2 組 USB",
                },
                {
                  modelName: "PTZ 通訊協定",
                  modelValue: "RS-485 介面 (Pelco D/P)",
                },
                {
                  modelName: "電源",
                  modelValue: "12V/4A",
                },
                {
                  modelName: "消耗電流",
                  modelValue: "48W",
                },
              ],
            },
            {
              type: "顯示",
              typeModel: [
                {
                  modelName: "解析度",
                  modelValue: "4K、1080P、720P、1024x768",
                },
                {
                  modelName: "分割畫面",
                  modelValue: "1、4、9、16、跳台",
                },
              ],
            },
            {
              type: "錄影",
              typeModel: [
                {
                  modelName: "錄影解析度",
                  modelValue: "5M、4M、3M(for IP)、1080P、720P、960H",
                },
                {
                  modelName: "錄影模式",
                  modelValue: "一般、位移、排程錄影",
                },
                {
                  modelName: "速度",
                  modelValue:
                    "5MP : 96 張/秒、4MP : 128 張/秒、1080P：240 張/秒",
                },
                {
                  modelName: "警報錄影",
                  modelValue: "有",
                },
                {
                  modelName: "排程錄影",
                  modelValue: "有",
                },
              ],
            },
            {
              type: "回放",
              typeModel: [
                {
                  modelName: "顯示",
                  modelValue: "1、4、9、16",
                },
                {
                  modelName: "搜尋模式",
                  modelValue: "日期、時間、事件(位移)",
                },
                {
                  modelName: "數位放大",
                  modelValue: "有",
                },
                {
                  modelName: "快照",
                  modelValue: "有",
                },
                {
                  modelName: "控制",
                  modelValue: "一般、暫停、停止、快放/倒轉、單張、搜尋 BAR",
                },
              ],
            },
            {
              type: "網路",
              typeModel: [
                {
                  modelName: "網路介面",
                  modelValue: "10/100 乙太網路",
                },
                {
                  modelName: "通訊協定",
                  modelValue: "TCP/IP、SMTP、HTTP、DHCP、PPPoE (ADSL)、NTP",
                },
                {
                  modelName: "應用程式",
                  modelValue: "Windows 7/8/10",
                },
                {
                  modelName: "遠端監控",
                  modelValue: "IE 瀏覽器、CMS 軟體、桌面專用軟體",
                },
                {
                  modelName: "登入帳號",
                  modelValue: "1 Admin + 20 User",
                },
                {
                  modelName: "CMS 中控平台",
                  modelValue: "有",
                },
                {
                  modelName: "手機 APP",
                  modelValue: "iPhone、iPad、Android",
                },
                {
                  modelName: "事件傳輸",
                  modelValue: "E-mail、APP 推播",
                },
              ],
            },
            {
              type: "備份",
              typeModel: [
                {
                  modelName: "介面",
                  modelValue: "USB0",
                },
                {
                  modelName: "備份方式",
                  modelValue: "網路遠端軟體、USB 隨身碟",
                },
              ],
            },
            {
              type: "警報",
              typeModel: [
                {
                  modelName: "位移偵測",
                  modelValue: "有",
                },
                {
                  modelName: "推播通知",
                  modelValue: "支援 APP 推播通知",
                },
                {
                  modelName: "事件紀錄",
                  modelValue:
                    "警報、位移、影像遺失、電源開關、錄影開關、遠端登入、硬碟錯誤",
                },
              ],
            },
            {
              type: "尺寸規格",
              typeModel: [
                {
                  modelName: "機身尺寸",
                  modelValue: "寬:320(mm) x 深:255(mm) x 高:48(mm)",
                },
              ],
            },
            {
              type: "OSD 及 DVR 控制",
              typeModel: [
                {
                  modelName: "GUI",
                  modelValue: "圖形化操作介面",
                },
                {
                  modelName: "多國語言",
                  modelValue: "中、英語言顯示操作",
                },
                {
                  modelName: "攝影機抬頭",
                  modelValue: "多國語言可任意由 PC 輸入",
                },
                {
                  modelName: "USB 滑鼠",
                  modelValue: "標準配備",
                },
                {
                  modelName: "UTC 控製",
                  modelValue: "有",
                },
                {
                  modelName: "系統升級",
                  modelValue: "經 USB 可更新 FIRMWARE(韌體)",
                },
              ],
            },
          ],
        },
      ],
      doorModel: [
        {
          id: 12,
          img: require("@/assets/product/AR721.png"),
          title: "AR-721<br>門禁刷卡機",
          altName: "AR-721門禁刷卡機",
          model: [
            {
              type: "規格",
              typeModel: [
                {
                  modelName: "感應頻率",
                  modelValue: "125kHz、13.56MHz",
                },
                {
                  modelName: "資料傳輸標準",
                  modelValue: "EM Standard(125kHz)、ISO14443A(13.56MHz)",
                },
                {
                  modelName: "感應距離",
                  modelValue: "10-18cm(125kHz)、2-8cm(13.56MHz)",
                },
                {
                  modelName: "消耗功率",
                  modelValue: "<3W",
                },
                {
                  modelName: "通訊介面",
                  modelValue: "RS-485",
                },
                {
                  modelName: "傳輸速率",
                  modelValue: "9600 bps(N,8,1)",
                },
                {
                  modelName: "工作電壓",
                  modelValue: "9-16VDC",
                },
                {
                  modelName: "DI輸入(點)",
                  modelValue: "開門按鈕/門位偵測",
                },
                {
                  modelName: "使用環境",
                  modelValue: "-20ﾟC to +60ﾟC",
                },
                {
                  modelName: "電鎖繼電器時間",
                  modelValue: "ON/OFF, 0.1-600 Sec",
                },
                {
                  modelName: "警報動作時間",
                  modelValue: "連動輸出, 1-600 Sec",
                },
                {
                  modelName: "使用人數",
                  modelValue: "",
                },
                {
                  modelName: "進出記錄",
                  modelValue: "1,200(限M4/M8)",
                },
                {
                  modelName: "外接門禁讀頭",
                  modelValue: "一組WG端口",
                },
                {
                  modelName: "一進一出管制",
                  modelValue: "Yes(限M4/M8)",
                },
                {
                  modelName: "樓層管制",
                  modelValue: "樓層32層,使用者1,024人",
                },
                {
                  modelName: "萬年曆",
                  modelValue: "Yes(限連網模式)",
                },
                {
                  modelName: "狀態顯示",
                  modelValue: "1組雙色LED+1組蜂鳴器",
                },
                {
                  modelName: "串列通訊輸出",
                  modelValue: "Yes(選購:321L485)(與警報輸出共點)",
                },
                {
                  modelName: "時段管制",
                  modelValue: "11組/63組(需接多門連網控制器)",
                },
                {
                  modelName: "外殼材質",
                  modelValue: "ABS外殼/橡膠按鍵",
                },
                {
                  modelName: "顏色",
                  modelValue: "深灰/銀色",
                },
                {
                  modelName: "外型尺寸(mm)",
                  modelValue: "111(L)X77(W)X26(H)",
                },
                {
                  modelName: "重量(g)",
                  modelValue: "100±10",
                },
              ],
            },
          ],
        },
        {
          id: 13,
          img: require("@/assets/product/AR725.png"),
          title: "AR-725<br>觸碰式背光門禁控制器",
          altName: "AR-725觸碰式背光門禁控制器",
          model: [
            {
              type: "規格",
              typeModel: [
                {
                  modelName: "感應頻率",
                  modelValue: "125kHz、13.56MHz",
                },
                {
                  modelName: "資料傳輸標準",
                  modelValue: "EM Standard(125kHz)、ISO14443A(13.56MHz)",
                },
                {
                  modelName: "感應距離",
                  modelValue: "",
                },
                {
                  modelName: "消耗功率",
                  modelValue: "<3W",
                },
                {
                  modelName: "通訊介面",
                  modelValue: "RS-485/9600 bps(N,8,1)",
                },
                {
                  modelName: "Ethernet",
                  modelValue: "No",
                },
                {
                  modelName: "串列通訊輸出",
                  modelValue: "TTL(Output:4800bps,N,8,1)",
                },
                {
                  modelName: "工作電壓",
                  modelValue: "9-16VDC",
                },
                {
                  modelName: "使用環境",
                  modelValue: "-20ﾟC to +60ﾟC",
                },
                {
                  modelName: "電鎖繼電器時間",
                  modelValue: "ON/OFF, 0.1-600 Sec",
                },
                {
                  modelName: "警報動作時間",
                  modelValue: "連動輸出, 1-600 Sec",
                },
                {
                  modelName: "使用人數",
                  modelValue: "",
                },
                {
                  modelName: "進出記錄",
                  modelValue: "1,500(限M4/M8)",
                },
                {
                  modelName: "樓層管制",
                  modelValue: "樓層32層,使用者3,000人",
                },
                {
                  modelName: "一進一出管制",
                  modelValue: "Yes(限M4/M8)",
                },
                {
                  modelName: "外接門禁讀頭",
                  modelValue: "一組WG端口",
                },
                {
                  modelName: "DI輸入(點)",
                  modelValue: "1*開門按鈕/1*門位偵測",
                },
                {
                  modelName: "狀態顯示",
                  modelValue: "1組雙色LED+1組蜂鳴器",
                },
                {
                  modelName: "按鍵材質",
                  modelValue: "觸碰式背光面板",
                },
                {
                  modelName: "操作模式",
                  modelValue: "單機/連線",
                },
                {
                  modelName: "時段管制",
                  modelValue: "11組/63組(需接多門連網控制器)",
                },
                {
                  modelName: "電晶體輸出",
                  modelValue:
                    "警戒燈指示(或數位繼電器訊號)/警報輸出/求援(反脅迫)",
                },
                {
                  modelName: "繼電器輸出",
                  modelValue: "電鎖繼電器",
                },
                {
                  modelName: "外殼材質",
                  modelValue: "PC(725H)",
                },
                {
                  modelName: "顏色",
                  modelValue: "標準:黑/灰/銀、選購:白/藍/綠/黃/橘/紅",
                },
                {
                  modelName: "其他選購模組",
                  modelValue: "",
                },
                {
                  modelName: "外型尺寸(mm)",
                  modelValue: "110(L)X79(W)X26(H)",
                },
                {
                  modelName: "重量(g)",
                  modelValue: "110±10",
                },
              ],
            },
          ],
        },
        {
          id: 14,
          img: require("@/assets/product/AR727.png"),
          title: "AR-727<br>液晶顯示門禁控制器",
          altName: "AR-727液晶顯示門禁控制器",
          model: [
            {
              type: "規格",
              typeModel: [
                {
                  modelName: "感應頻率",
                  modelValue: "125kHz、13.56MHz",
                },
                {
                  modelName: "資料傳輸標準",
                  modelValue: "EM Standard(125kHz)、ISO14443A(13.56MHz)",
                },
                {
                  modelName: "感應距離",
                  modelValue: "5-15 cm(125kHz)、2-5 cm(13.56MHz)",
                },
                {
                  modelName: "消耗功率",
                  modelValue: "<5W",
                },
                {
                  modelName: "通訊介面",
                  modelValue: "RS-485/Ethernet(選購)",
                },
                {
                  modelName: "傳輸速率",
                  modelValue:
                    "9600 bps(N,8,1)(125kHz)、10/100M Base T(13.56MHz)",
                },
                {
                  modelName: "工作電壓",
                  modelValue: "10-24VDC",
                },
                {
                  modelName: "DI輸入(點)",
                  modelValue: "2*開門按鈕/2*門位偵測",
                },
                {
                  modelName: "使用環境",
                  modelValue: "-10ﾟC to +60ﾟC",
                },
                {
                  modelName: "電鎖繼電器時間",
                  modelValue: "ON/OFF, 0.1-600 Sec",
                },
                {
                  modelName: "警報動作時間",
                  modelValue: "連動輸出, 1-600 Sec",
                },
                {
                  modelName: "使用人數",
                  modelValue: "標準:16,000、客製:32,000/65,000",
                },
                {
                  modelName: "進出記錄",
                  modelValue: "32,000",
                },
                {
                  modelName: "外接門禁讀頭",
                  modelValue: "一組WG端口",
                },
                {
                  modelName: "一進一出管制",
                  modelValue: "Yes",
                },
                {
                  modelName: "樓層管制",
                  modelValue: "樓層64層,使用者16,000人",
                },
                {
                  modelName: "萬年曆",
                  modelValue: "Yes",
                },
                {
                  modelName: "串列通訊輸出",
                  modelValue: "Yes(選購:AR-725L485)",
                },
                {
                  modelName: "狀態顯示",
                  modelValue: "6組LED+1組蜂鳴器",
                },
                {
                  modelName: "按鍵材質",
                  modelValue: "橡膠",
                },
                {
                  modelName: "操作模式",
                  modelValue: "單機/連線",
                },
                {
                  modelName: "時段管制",
                  modelValue: "63組",
                },
                {
                  modelName: "電晶體輸出",
                  modelValue:
                    "警戒燈指示/警報輸出/求援(反脅迫)/WG電鎖/數位繼電器訊號",
                },
                {
                  modelName: "繼電器輸出",
                  modelValue: "警報繼電器/電鎖繼電器",
                },
                {
                  modelName: "LCD顯示螢幕",
                  modelValue: "有",
                },
                {
                  modelName: "外殼材質",
                  modelValue: "ABS",
                },
                {
                  modelName: "顏色",
                  modelValue: "深灰",
                },
                {
                  modelName: "門鈴按鈕",
                  modelValue: "無",
                },
                {
                  modelName: "其他選購模組",
                  modelValue: "AR-MDL-721V(語音模組)",
                },
                {
                  modelName: "外型尺寸(mm)",
                  modelValue: "126(L)X91(W)X46(H)",
                },
                {
                  modelName: "重量(g)",
                  modelValue: "220±10",
                },
              ],
            },
          ],
        },
        {
          id: 15,
          img: require("@/assets/product/AR837.png"),
          title: "AR-837<br>指紋型門禁控制器",
          altName: "AR-837指紋型門禁控制器",
          model: [
            {
              type: "規格",
              typeModel: [
                {
                  modelName: "感應頻率",
                  modelValue: "125kHz、13.56MHz、雙頻",
                },
                {
                  modelName: "資料傳輸標準",
                  modelValue:
                    "EM Standard(125kHz)、ISO14443A(13.56MHz)、EM Standard(雙頻)、ISO14443A(雙頻)",
                },
                {
                  modelName: "感應距離",
                  modelValue:
                    "5-15 cm(125kHz)、2-5 cm(13.56MHz)、125kHz:5-15cm(雙頻)、13.56MHz:2-5cm(雙頻)",
                },
                {
                  modelName: "消耗功率",
                  modelValue: "<5W",
                },
                {
                  modelName: "傳輸速率",
                  modelValue: "",
                },
                {
                  modelName: "通訊介面",
                  modelValue: "RS-485/Ethernet(選購)",
                },
                {
                  modelName: "工作電壓",
                  modelValue: "10-24VDC",
                },
                {
                  modelName: "DI輸入(點)",
                  modelValue: "2*開門按鈕/2*門位偵測",
                },
                {
                  modelName: "使用環境",
                  modelValue: "0ﾟC to +60ﾟC",
                },
                {
                  modelName: "電鎖繼電器時間",
                  modelValue: "常態輸出, 0.1-600 Sec",
                },
                {
                  modelName: "警報動作時間",
                  modelValue: "連動輸出, 1-600 Sec",
                },
                {
                  modelName: "使用人數",
                  modelValue: "卡片16,000；指紋9,000(DO/MT)/500(3DO)",
                },
                {
                  modelName: "進出記錄",
                  modelValue: "32,000",
                },
                {
                  modelName: "外接門禁讀頭",
                  modelValue: "一組WG端口",
                },
                {
                  modelName: "一進一出管制",
                  modelValue: "Yes",
                },
                {
                  modelName: "樓層管制",
                  modelValue: "樓層64層,使用者16,000人",
                },
                {
                  modelName: "萬年曆",
                  modelValue: "Yes",
                },
                {
                  modelName: "狀態顯示",
                  modelValue: "6組LED+1組蜂鳴器",
                },
                {
                  modelName: "按鍵材質",
                  modelValue: "背光橡膠",
                },
                {
                  modelName: "操作模式",
                  modelValue: "單機/連線",
                },
                {
                  modelName: "時段管制",
                  modelValue: "63組",
                },
                {
                  modelName: "電晶體輸出",
                  modelValue:
                    "警戒燈指示/警報輸出/求援(反脅迫)WG電鎖/數位繼電器訊號",
                },
                {
                  modelName: "繼電器輸出",
                  modelValue: "警報繼電器/電鎖繼電器",
                },
                {
                  modelName: "LCD顯示螢幕",
                  modelValue: "128*64點陣(中英文4行顯示)",
                },
                {
                  modelName: "外殼材質",
                  modelValue: "ABS",
                },
                {
                  modelName: "顏色",
                  modelValue: "黑邊或銀邊",
                },
                {
                  modelName: "假率/拒真率(FRR)",
                  modelValue: "<0.1%",
                },
                {
                  modelName: "手指資料容量",
                  modelValue:
                    "DO/MT:4,500 - 9,000人(每人1或2枚)、3DO: 500人(每人3枚)",
                },
                {
                  modelName: "認證速度(一對多)",
                  modelValue: "0.79秒",
                },
                {
                  modelName: "指紋模組",
                  modelValue: "400MHz DSP",
                },
                {
                  modelName: "門鈴按鈕",
                  modelValue: "有",
                },
                {
                  modelName: "其他選購模組",
                  modelValue: "HID卡片感應模組、AR-MDL-721V:語音模組",
                },
                {
                  modelName: "外型尺寸(mm)",
                  modelValue: "133(L)X147(W)X65/30(H)",
                },
                {
                  modelName: "重量(g)",
                  modelValue: "450±10(DO),400±10(MT)",
                },
              ],
            },
          ],
        },
      ],
    };
  },
  methods: {
    cardmodal(title, img, model) {
      this.cardDialog = true;
      this.cardDialogTitle = title;
      this.productModelImg = img;
      this.productModelValue = model;
      this.itemRow = model.length;
    },
    checkCardHover(productValue) {
      this.cardhover.hoverId = productValue.id;
      this.cardhover.ishover = !this.cardhover.ishover;
    },
  },
};
</script>

<style lang="scss" scoped>
.product {
  width: 100%;
  height: 2350px;
}
.producttext {
  width: 80%;
  margin: auto;
  position: relative;
  top: 70px;
}
.producttitle {
  z-index: 1;
  font-weight: bold;
  font-size: 1.7em;
  color: #414141;
  margin-bottom: 30px;
}
.clickimg {
  font-size: 0.7em;
  color: #727272;
  margin-left: 10px;
}
.productmodel {
  margin-bottom: 10px;
}
.productitem {
  display: flex;
  align-items: center;
  font-size: 1.35em;
  margin-bottom: 10px;
}
.producticon {
  width: 30px;
  height: 30px;
}
.productitemname {
  font-size: 21.6px;
  font-weight: bold;
  color: #4b4848;
  margin: 0   !important;
}
.monitorscard {
  width: 100%;
  height: 1000px;
  display: grid;
  grid-template-columns: repeat(3, 28%);
  grid-template-rows: repeat(3, 300px);
  grid-column-gap: 8%;
  grid-row-gap: 50px;
  margin-bottom: 30px;
}
.card {
  width: 100%;
  height: 100%;
}
.productcardcontent {
  width: 100%;
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
}
.productcardhovertrue {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-wrap: wrap;
  background-color: #525252d0;
  color: white;
  position: absolute;
  text-align: center;
  z-index: 2;
  transform: translateX(0);
  transition: transform 0.3s ease-in-out;
}
.productcardhoverfalse {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-wrap: wrap;
  position: absolute;
  text-align: center;
  background-color: #525252d0;
  color: white;
  z-index: 2;
  transform: translateX(101%);
  transition: transform 0.3s ease-in-out;
}
.productcardhover-title {
  width: 100%;
}
.productcardhover-more {
  padding: 5px;
  box-sizing: border-box;
  border-radius: 3px;
  border: 1px solid #d1a735;
}
.productimg {
  width: 200px;
}
.productcardimg {
  width: 100%;
  height: 100%;
  // transform: scale(1);
  // transition: transform 0.3s ease-in-out;
}
// .productcardimg:hover {
//   transform: scale(1.15);
//   transition: transform 0.3s ease-in-out;
// }
.productcardtitle {
  width: 100%;
  height: 80px;
  background-color: rgb(172, 172, 172);
  color: rgb(61, 61, 61);
  text-align: center;
  font-weight: bold;
  font-size: 1.1em;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
}
.dvrcard {
  width: 100%;
  height: 300px;
  display: grid;
  grid-template-columns: repeat(3, 28%);
  grid-template-rows: 300px;
  grid-column-gap: 8%;
  margin-bottom: 30px;
}
.doorcard {
  width: 100%;
  height: 300px;
  display: grid;
  grid-template-columns: repeat(3, 28%);
  grid-template-rows: repeat(2, 300px);
  grid-column-gap: 8%;
  grid-row-gap: 50px;
  margin-bottom: 30px;
}
.dialog-title {
  border-bottom: 3px solid #213766;
  color: #213766;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  padding: 10px;
}
.dialog-name {
  font-size: 1.5em;
  font-weight: bold;
}
.productmodelimg {
  height: 150px;
}
.productmodeltable {
  width: 100%;
  font-weight: bold;
  font-size: 1.3em;
  display: inline-flex;
  flex-wrap: wrap;
  align-content: flex-start;
  justify-content: space-between;
}
.productmodelcardone {
  width: 100%;
  border: 1px solid rgba(133, 133, 133, 0.2);
  margin-bottom: 15px;
}
.productmodelcardoneup {
  width: 49%;
  border: 1px solid rgba(133, 133, 133, 0.2);
  margin-bottom: 15px;
}
.modelvalue {
  padding-left: 15px;
}
.modelLi {
  border-bottom: 1px solid rgba(70, 70, 70, 0.2);
  color: rgb(70, 70, 70);
}
.modelType {
  width: 100%;
  height: 35px;
  line-height: 35px;
  background-color: rgb(49, 49, 49);
  color: #f4d271;
  text-align: center;
}
@media screen and (max-width: 1000px) {
  .product {
    width: 100%;
    height: 3000px;
  }
  .monitorscard {
    height: 1300px;
    display: grid;
    grid-template-columns: repeat(2, 46%);
    grid-template-rows: repeat(4, 300px);
    grid-column-gap: 8%;
    grid-row-gap: 30px;
  }
  .dvrcard {
    height: 650px;
    display: grid;
    grid-template-columns: repeat(2, 46%);
    grid-template-rows: repeat(2, 300px);
    grid-column-gap: 8%;
    grid-row-gap: 30px;
  }
  .doorcard {
    height: 650px;
    display: grid;
    grid-template-columns: repeat(2, 46%);
    grid-template-rows: repeat(2, 300px);
    grid-column-gap: 8%;
    grid-row-gap: 30px;
  }
}
@media screen and (max-width: 700px) {
  .product {
    height: 3640px;
  }
  .producttitle {
    font-size: 1.3em;
  }
  .clickimg {
    display: block;
    margin-left: 0px;
  }
  .monitorscard,
  .dvrcard,
  .doorcard {
    width: 100%;
    display: block;
  }
  .monitorscard {
    height: 1745px;
  }
  .card {
    width: 100%;
    height: 190px;
    margin-bottom: 30px;
  }
  .productcardcontent {
    width: 100%;
    height: 110px;
    padding: 10px;
    margin: auto;
    justify-content: center;

    position: relative;
  }

  .productimg {
    width: 129.41px;
    height: 100%;
  }
  .productcardimg {
    width: 100%;
    height: 100%;
  }
  .productcardtitle {
    width: 100%;
    height: 60px;
    font-size: 0.97em;
  }
  .productmodeltable {
    width: 100%;
    display: block;
  }
  .dialog-title {
    display: block;
    text-align: center;
  }
  .dialog-name {
    font-size: 1.2em;
    font-weight: bold;
    display: block;
    margin-bottom: 10px;
  }
  .productmodelimg {
    width: 117.64px;
    height: 100px;
    margin: auto;
  }
  .productmodelcardone,
  .productmodelcardoneup {
    width: 100%;
  }

  .modelLi {
    font-size: 0.8em;
  }
}
@media screen and (max-width: 380px) {
  .productcardtitle {
    font-size: 0.9em;
  }
  .modelLi {
    font-size: 0.7em;
  }
}
</style>
